import React, {Component} from 'react';
import {observer} from 'mobx-react';
import ContentWrap from "../../components/layout/ContentWrap";
import InfiniteScroll from "react-infinite-scroller";
import {Button, Col, Container, FormControl, InputGroup, Row} from "react-bootstrap";
import Styles from './TagView.module.scss'
import {MagnifyingGlass} from "react-loader-spinner";
import {tagStore} from "../../store/TagStore";
import Tag from "../../components/tag/Tag";
import Masonry, {ResponsiveMasonry} from 'react-responsive-masonry';
import SortDropDown from "../../components/media/SortDropDown";
import {navigate} from "../../helper/HistoryHelper";

const SORT_TYPE = {
    id: '등록순',
    mediaCount: '영상수',
}


@observer
class TagView extends Component {

    constructor(props) {
        super(props);

    }

    componentDidMount() {
        let store = tagStore;
        setTimeout(() => {
            store.scrollRef.current.scrollTo(0, store.scrollTop)
        }, 50)

    }

    componentWillUnmount() {
    }

    render() {
        let store = tagStore;
        return (
            <ContentWrap>
                <div className={Styles.SearchBar}>
                    <Container className={`p-0 d-flex justify-content-between`}>
                        <div className={`d-flex flex-grow-1 text-nowrap`}>
                            <SortDropDown store={store}
                                          option={SORT_TYPE}
                            />
                        </div>
                        <div>
                            <InputGroup>
                                <FormControl size={'sm'}
                                             value={store.keyword}
                                             onChange={e => {
                                                 store.keyword = e.target.value
                                             }}
                                             onKeyDown={e => {
                                                 if (e.key === 'Enter') {
                                                     store.searchCondition.set("keyword", store.keyword)
                                                     store.debounceFetch(true);
                                                 }
                                             }}
                                />
                                <Button variant={"outline-light"} size={'sm'}
                                        onClick={() => {
                                            store.searchCondition.set("keyword", store.keyword)
                                            store.debounceFetch(true);
                                        }}
                                >
                                    검색
                                </Button>
                            </InputGroup>
                        </div>
                    </Container>
                </div>
                <div className={Styles.Content}
                     ref={store.scrollRef}
                     onScroll={store.onScrollHandler}
                >
                    <InfiniteScroll
                        loadMore={(page) => {
                            store.debounceFetch(false)
                        }}
                        hasMore={store.tags.length < store.count}
                        loader={
                            <div key={"a"}>
                            </div>
                        }
                        useWindow={false}
                        threshold={5}
                    >
                        <Container className={`p-0`}>
                            <ResponsiveMasonry columnsCountBreakPoints={{576: 2, 768: 2, 992: 3, 1200: 4, 1400: 5}}
                                               sequential={true}>
                                <Masonry sequential={true} gutter={'1rem'}>
                                    {
                                        !store.isFetching && store.tags.length < 1 &&
                                        <div className={`align-items-center justify-content-center d-flex p-5`}>
                                            검색 결과가 없습니다.
                                        </div>
                                    }
                                    {
                                        store.tags.map(tag => {
                                            return (
                                                <div key={`ACTOR-${tag.id}`} style={{width: '100%'}}>
                                                    <Tag tag={tag} store={store}
                                                         onClick={() => {
                                                             navigate(`/main/tag/${this.props.match.params.type}/${tag.id}`)
                                                         }}
                                                    />
                                                </div>
                                            )
                                        })
                                    }
                                    {
                                        store.isFetching &&
                                        <Col sm={12} md={12} xl={12}
                                             className={`d-flex justify-content-center align-items-center p-5`}>
                                            <MagnifyingGlass
                                                visible={true}
                                                height="80"
                                                width="80"
                                                ariaLabel="magnifying-glass-loading"
                                                wrapperStyle={{}}
                                                wrapperClass="magnifying-glass-wrapper"
                                                glassColor="#c0efff"
                                                color="#afafaf"
                                            />

                                        </Col>
                                    }
                                </Masonry>
                            </ResponsiveMasonry>

                        </Container>
                    </InfiniteScroll>
                </div>
            </ContentWrap>
        );
    }
}

TagView.propTypes = {};

export default TagView;
